import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import ComponentModal, { ModalSize } from "./ComponentModal";
import ErrorPanel, { ErrorSize } from "../ErrorPanel/ErrorPanel";

import LogService from "../../../middleware/CommonSdk/LogService";

export { ModalSize };

const LOG_TAG = "BILLING_MODAL";
const ModalId = "CreateZuoraPaymentMethodModalId";

const CreateZuoraPaymentMethodModal = (props) => {
    const intl = useIntl();
    const [modal, setModal] = useState(null);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect didmount");
        setModal(
            <ComponentModal
                id={ModalId}
                title={props.title}
                icon={props.icon}
                iconColor={props.iconColor}
                size={props.modalSize}
                showFirstButton={false}
                showModalOnInit={true}
                onClose={() => setModal(null)}
                footer={props.footer}
            >
                {props.getComponent(handleOnSuccess, handleOnFailed)}
            </ComponentModal>
        );
    }, [props.getComponent]);

    const handleOnSuccess = () => {
        LogService.debug(LOG_TAG, "handleOnSuccess");
        setModal(
            <ComponentModal
                id={ModalId}
                closeModal={true}
            />
        );
    }

    const handleOnFailed = (errorPayload) => {
        LogService.debug(LOG_TAG, "handleOnFailed");
        setModal(
            <ComponentModal
                id={ModalId}
                title={props.title}
                titleColor="warning"
                icon={props.icon}
                iconColor="warning"
                showFirstButton={true}
                firstButtonLabel={intl.messages.close}
                onClick={() => setModal(null)}
                showModalOnInit={true}
                size={props.modalSize}
            >
                {intl.messages.errorMessagePaymentSomethingWrong}
                <ErrorPanel id="option-error" size={ErrorSize.Small}>{errorPayload.errorCode} : {errorPayload.errorMessage}</ErrorPanel>
            </ComponentModal>
        );
    }

    LogService.trace(LOG_TAG, "render");

    return (
        <div>
            {modal}
        </div>
    );
}

CreateZuoraPaymentMethodModal.defaultProps = {
    title: "",
    icon: null,
    iconColor: "pink",
    getComponent: null,
    modalSize: ModalSize.Medium,
    footer: null
}

CreateZuoraPaymentMethodModal.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.object,
    iconColor: PropTypes.string,
    getComponent: PropTypes.func,
    modalSize: PropTypes.oneOf(Object.keys(ModalSize)),
    footer: PropTypes.object
};

export default CreateZuoraPaymentMethodModal;